<script lang="ts">
	//
	import {
		AdaptiveTextInput,
		DefaultButton,
		InlineButton,
	} from "@hitit/new_ui";
	import CollectionPopup from "@hitit/hub/src/v7/components/product/CollectionPopup.svelte";
	//Utils
	import { createEventDispatcher } from "svelte";
	import { clickOutside } from "@hitit/utils";
	import { t } from "@hitit/hub/src/stores";
	import type { FAQ_Category } from "../../class/FAQ/FAQ_Manager";

	export let existCategoryNames: string[] = [];
	export let category: FAQ_Category;
	export let clickOutsideCallBack = () => {};

	let inputValue = category.name;
	let inputError = false;
	const dispatch = createEventDispatcher();
	const deleteEvent = () => dispatch("DELETE_CATEGORY", category);

	const nameButtonHandler = () => {
		const emptyCondition = inputValue === "";
		const hasSameName =
			existCategoryNames.find((v) => v === inputValue) !== undefined;
		if (emptyCondition || hasSameName) return (inputError = true);

		dispatch("UPDATE_CATEGORY", inputValue);
	};

</script>

<div class="container" use:clickOutside={clickOutsideCallBack}>
	<CollectionPopup>
		<div class="inner">
			<div class="f-col">
				<label for="">{$t('global.product.category.edit_category_name')}</label>
				<div class="input-button">
					<div class="input">
						<AdaptiveTextInput
							bind:value={inputValue}
							error={inputError}
							placeholder={$t('global.product.category.category_name')} />
					</div>
					<div class="button">
						<DefaultButton fitmode on:click={nameButtonHandler} nonePadding>
							<span class="button-inner">{$t('global.save')}</span>
						</DefaultButton>
					</div>
				</div>
			</div>
			<div class="seperate" />
			<div class="f-between">
				<label for="">{$t('global.product.category.delete_category')}</label>
				<InlineButton on:click={deleteEvent}>
					<img id="delete" src="/icons/deleteIcon.png" alt="" />
				</InlineButton>
			</div>
		</div>
	</CollectionPopup>
</div>

<style lang="scss">
	@import "../../../variables.scss";

	.container {
		position: absolute;
		left: 0;
		top: 46px;
		z-index: 9;

		&:hover {
			cursor: default;
		}

		#delete {
			width: 26px;
			height: 26.2px;
		}

		.seperate {
			width: 100%;
			height: 1px;
			background-color: #bcbfc3;
		}

		.inner {
			display: flex;
			flex-direction: column;
			gap: 10px;
		}

		.button-inner {
			color: white;
			font-weight: 500;
			font-size: 1rem;
			line-height: 26px;
		}

		.f-between {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		.input-button {
			display: flex;
			gap: 10px;
			height: 32px;

			.input {
				font-size: 1rem;
				color: #46474b;
				flex-grow: 1;
			}

			.button {
				width: 60px;
			}
		}

		.f-col {
			display: flex;
			flex-direction: column;
			gap: 10px;
		}

		label {
			color: white;
		}
	}

	@include DesktopSize {
		.container {
			.inner {
				gap: 24px;
			}

			.button-inner {
				font-size: 1.25rem;
			}

			.input-button {
				height: 40px;
			}

			label {
				font-size: 1.25rem;
			}
		}
	}

</style>
